import { Component, Input } from "@angular/core"
import NavigationNode from "../../../models/navigationNode.model"
import { Colors } from "../../../models/colors.model"
import { ColorCodeService } from "../../../services/color-code.service"
import { GTMComponent } from "../../../utils/gtmComponent"

@Component({
    selector: "app-side-navigation-nodes",
    templateUrl: "./side-navigation-nodes.component.html",
    styleUrls: ["./side-navigation-nodes.component.scss"],
})
export class SideNavigationNodesComponent extends GTMComponent {
    @Input() childrenNodes: NavigationNode[]
    @Input() activeNode: NavigationNode
    @Input() color: string = "#2c40cb"
    @Input() firstLevel: boolean = false
    @Input() styles: Colors = new Colors({})
    expandedNodes: { [id: number]: boolean } = {}

    constructor(private colorCodeService: ColorCodeService) {
        super()
    }

    ngOnChanges() {
        this.childrenNodes.forEach((node) => {
            this.expandedNodes[node.id] = this.isExpanded(node)
        })
    }

    public getBackgroundColor(node: NavigationNode) {
        if (this.isActive(node)) {
            if (this.styles.isEnabled) {
                return {
                    background: this.styles.colorBkgd,
                    color: this.styles.colorText,
                }
            }
            return {
                background: this.colorCodeService.collectionColors.defaultBackgroundColor,
                color: this.colorCodeService.collectionColors.defaultTextColor,
            }
        }
        return { background: "transparent" }
    }

    public getDetailColor(node: NavigationNode) {
        if (this.styles.isEnabled) {
            if (this.isActive(node)) {
                return { color: this.styles.colorText }
            }
            return { color: this.styles.colorDetail }
        }
        return {}
    }

    public isActive(node: NavigationNode) {
        if (this.activeNode) {
            return node.id === this.activeNode.id
        }
        return false
    }

    public isExpanded(node: NavigationNode) {
        let hasActiveChildren = null
        if (this.activeNode) {
            hasActiveChildren = node.children.find((child) => {
                return child.id === this.activeNode.id
            })
        }
        return this.isActive(node) || !!hasActiveChildren
    }

    public expandNode(event: MouseEvent, node: NavigationNode) {
        event.preventDefault()
        event.stopPropagation()
        this.expandedNodes[node.id] = !this.expandedNodes[node.id]
    }
}
